export const USER_DASHBOARD_LIST_REQUEST = 'USER_DASHBOARD_LIST_REQUEST'
export const USER_DASHBOARD_LIST_SUCCESS = 'USER_DASHBOARD_LIST_SUCCESS'
export const USER_DASHBOARD_LIST_FAIL = 'USER_DASHBOARD_LIST_FAIL'
export const USER_DASHBOARD_LIST_RESET = 'USER_DASHBOARD_LIST_RESET'

export const USER_DASHBOARD_BY_USER_REQUEST = 'USER_DASHBOARD_BY_USER_REQUEST'
export const USER_DASHBOARD_BY_USER_SUCCESS = 'USER_DASHBOARD_BY_USER_SUCCESS'
export const USER_DASHBOARD_BY_USER_FAIL = 'USER_DASHBOARD_BY_USER_FAIL'

export const USER_DASHBOARD_DEFAULT_REQUEST = 'USER_DASHBOARD_DEFAULT_REQUEST'
export const USER_DASHBOARD_DEFAULT_SUCCESS = 'USER_DASHBOARD_DEFAULT_SUCCESS'
export const USER_DASHBOARD_DEFAULT_FAIL = 'USER_DASHBOARD_DEFAULT_FAIL'

export const USER_DASHBOARD_DETAILS_REQUEST = 'USER_DASHBOARD_DETAILS_REQUEST'
export const USER_DASHBOARD_DETAILS_SUCCESS = 'USER_DASHBOARD_DETAILS_SUCCESS'
export const USER_DASHBOARD_DETAILS_FAIL = 'USER_DASHBOARD_DETAILS_FAIL'
export const USER_DASHBOARD_DETAILS_RESET = 'USER_DASHBOARD_DETAILS_RESET'

export const USER_DASHBOARD_CREATE_REQUEST = 'USER_DASHBOARD_CREATE_REQUEST'
export const USER_DASHBOARD_CREATE_SUCCESS = 'USER_DASHBOARD_CREATE_SUCCESS'
export const USER_DASHBOARD_CREATE_FAIL = 'USER_DASHBOARD_CREATE_FAIL'
export const USER_DASHBOARD_CREATE_RESET = 'USER_DASHBOARD_CREATE_RESET'

export const USER_DASHBOARD_UPDATE_REQUEST = 'USER_DASHBOARD_UPDATE_REQUEST'
export const USER_DASHBOARD_UPDATE_SUCCESS = 'USER_DASHBOARD_UPDATE_SUCCESS'
export const USER_DASHBOARD_UPDATE_FAIL = 'USER_DASHBOARD_UPDATE_FAIL'
export const USER_DASHBOARD_UPDATE_RESET = 'USER_DASHBOARD_UPDATE_RESET'

export const USER_DASHBOARD_DELETE_REQUEST = 'USER_DASHBOARD_DELETE_REQUEST'
export const USER_DASHBOARD_DELETE_SUCCESS = 'USER_DASHBOARD_DELETE_SUCCESS'
export const USER_DASHBOARD_DELETE_FAIL = 'USER_DASHBOARD_DELETE_FAIL'

export const USER_DASHBOARD_DTO_REQUEST = 'USER_DASHBOARD_DTO_REQUEST'
export const USER_DASHBOARD_DTO_SUCCESS = 'USER_DASHBOARD_DTO_SUCCESS'
export const USER_DASHBOARD_DTO_FAIL = 'USER_DASHBOARD_DTO_FAIL'
export const USER_DASHBOARD_DTO_RESET = 'USER_DASHBOARD_DTO_RESET'

export const USER_DASHBOARD_LIST_BY_IDS_REQUEST = 'USER_DASHBOARD_LIST_BY_IDS_REQUEST'
export const USER_DASHBOARD_LIST_BY_IDS_SUCCESS = 'USER_DASHBOARD_LIST_BY_IDS_SUCCESS'
export const USER_DASHBOARD_LIST_BY_IDS_FAIL = 'USER_DASHBOARD_LIST_BY_IDS_FAIL'
export const USER_DASHBOARD_LIST_BY_IDS_RESET = 'USER_DASHBOARD_LIST_BY_IDS_RESET'
